var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.75 10.7495V5.24951C3.75 5.0506 3.82902 4.85983 3.96967 4.71918 4.11032 4.57853 4.30109 4.49951 4.5 4.49951H19.5C19.6989 4.49951 19.8897 4.57853 20.0303 4.71918 20.171 4.85983 20.25 5.0506 20.25 5.24951V10.7495C20.25 18.626 13.5651 21.2355 12.2303 21.678 12.0811 21.7294 11.9189 21.7294 11.7697 21.678 10.4349 21.2355 3.75 18.626 3.75 10.7495zM3.80859 12H20.1914M12 4.5V21.7166", stroke: "#222429", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});